import { EmployerModuleType } from "../../models/accounts/employerModuleType";
import { CreatePlanInput } from "../../components/plans/CreatePlanInput";
import { AccountKind } from "../../models/accounts/accountKind";

export const createPlan = async (
  config: any,
  employerId: string,
  token: string | undefined,
  values: CreatePlanInput,
  moduleType: EmployerModuleType,
  accountKind?: AccountKind
) => {
    //TODO: Validate this based on module type I.E. Allocations/Reward accounts do not have service sectors as they cannot be used to purchase.
  if (!values.serviceSectorIds.length) {
    throw new Error("Plan must have at least 1 category selected");
  }

  if (!values.tiers.length) {
    throw new Error("Plan must have at least 1 tier");
  }

  const response = await fetch(
    `${config?.API_URL}/employers/${employerId}/plans`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        name: values.name,
        serviceSectorIds: values.serviceSectorIds,
        tiers: values.tiers.map((tier) => {
          return {
            name: tier.name,
            amount: tier.amount.amount
          };
        }),
        type: values.planType,
        employerModuleType: moduleType,
        accountKind: accountKind,
        renewalOptions: values.renewalOptions,
        controls: {
          purchases: values.purchases,
          payments: values.payments,
          management: values.management
        }
      })
    }
  );

  if (!response.ok)
    throw new Error("There was a problem creating this plan");
}; 